"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.TranslationEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var entity_factory_1 = require("./entity-factory");
var typeToPrefix = function (prismicType) {
    return prismicType.replace('translation_', '').toUpperCase();
};
exports.TranslationEntity = entity_factory_1.entityFactory(types_1.TranslationType.Translation, function (prismicDoc, normalizedEntity) {
    var prefix = typeToPrefix(prismicDoc.type);
    return utils_1.compact(__assign(__assign({}, normalizedEntity), { type: types_1.TranslationType.Translation, body: Object.entries(prismicDoc.data).reduce(function (acc, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (__assign(__assign({}, acc), (_b = {}, _b[prefix + "_" + key] = value, _b)));
        }, {}) }));
});
//# sourceMappingURL=translation.js.map